module.exports = __webpack_public_path__ + "static/media/agnus-dei-p2.17347d3c.jpg";